import React from 'react';
import I18n from 'i18n-js';
import { useExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { updateGoogleConsent } from '@reverbdotcom/commons/src/google';

import UserPrivacySettingModal from './user_privacy_setting_modal';
import experiments from '@reverbdotcom/commons/src/experiments';
import { V3 } from './api_request';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import Location from '../../src/lib/wrapped_location';

const COMPONENT_NAME = 'UserPrivacySetting';

export default function UserPrivacySetting() {
  const { thirdPartyAdDataAllowed } = useUser();
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [isChecked, setPrivacySetting] = React.useState(thirdPartyAdDataAllowed);

  const isGoogleConsentModeOn = useExpEnabled(experiments.GOOGLE_CONSENT_MODE);

  const closeModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const openModal = React.useCallback(() => {
    setModalOpen(true);

    trackEvent({
      eventName: MParticleEventName.OpenedPrivacySettingsModal,
      componentName: COMPONENT_NAME,
    });
  }, []);

  const handleSubmit = () => {
    const mparticleId = window.mParticle.Identity.getCurrentUser?.().getMPID();

    V3.post(Paths.privacySettingsUpdate.expand({}),
      {
        third_party_ad_data_consent: isChecked,
        mparticle_id: mparticleId,
      },
    ).then(() => {
      if (isGoogleConsentModeOn) {
        updateGoogleConsent(isChecked);
      }
      Location.assign(Location.href);
    });
  };

  const updatePrivacySetting = React.useCallback((e) => {
    setPrivacySetting(e.target.checked);
  }, []);

  return (
    <button
      type="button"
      className="site-footer-v2__link"
      onClick={openModal}
    >
      <UserPrivacySettingModal
        onSubmit={handleSubmit}
        isChecked={isChecked}
        updatePrivacySetting={updatePrivacySetting}
        onClose={closeModal}
        isOpen={isModalOpen}
      />
      {I18n.t('discovery.privacySettingsModal.privacySettings.title')}
    </button>
  );
}
